// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"20f38d88","239":"ece04376","453":"c672c10a","455":"ad9e1c0c"}[chunkId] + ".chunk.js";
};